import React from "react";
import { createUseStyles } from "react-jss";
import { DropdownOptions, ListCell } from "../..";
import { OverlayStyle, OverlayTrigger } from "../../OverlayTrigger";
import { THEME } from "../../theming/theming";
import { classNames } from "../../utils/classNames";
import { isDefined } from "../../utils/isDefined";
import { TableDropdownAction } from "../TableDropdown";
import { getCellDataId, getCellDataTestId } from "../tableUtils";
import { RowChevron } from "./RowChevron";
import { getCellLinkProps, getBoolValueFromRow } from "./utilsV2Table";
import { v4 as uuidv4 } from "uuid";
export function TableRowAction(props) {
    const { item, dropdown, rowIndex } = props;
    const classes = useTableActionClasses(props);
    const tableHasDropdown = isDefined(props?.dropdown);
    const rowIsDisabled = getBoolValueFromRow(item, props.disabledRows);
    const cellLink = getCellLinkProps(item, props?.link, props?.onSelect, props.linkBuilder);
    const cellDataId = getCellDataId(rowIndex, props?.dataId);
    const cellDataTestId = getCellDataTestId(rowIndex, props?.dataTestId);
    const handleOptionSelection = (option, item) => {
        option.onClick && option.onClick(item);
    };
    const uniqueId = uuidv4();
    const numberOfColumns = props?.headings.length;
    const colIndex = props.drawer ? numberOfColumns + 2 : numberOfColumns + 1;
    return (React.createElement(ListCell, { className: classNames("table-listRowAction", tableHasDropdown ? classes.dropdown : classes.arrow, classes.action), ariaColIndex: colIndex, role: "cell", link: !rowIsDisabled && !dropdown ? cellLink : undefined, dataId: cellDataId && `${cellDataId}-action`, dataTestId: cellDataTestId && `${cellDataTestId}-action`, dataHook: "table-dropdown" }, dropdown ? (React.createElement(OverlayTrigger, { overlayTrigger: React.createElement(TableDropdownAction, { id: uniqueId, haspopup: true, dataId: cellDataId, dataTestId: cellDataTestId }), placement: "bottom-end", overlayContent: React.createElement(DropdownOptions, { options: dropdown, id: cellDataTestId ?? "", item: item, onChange: (option, _ev, item) => handleOptionSelection(option, item) }), triggerType: "click", overlayStyle: OverlayStyle.Dropdown })) : (React.createElement(RowChevron, { disabled: rowIsDisabled }))));
}
export function useTableActionClasses(props) {
    const useStyles = createUseStyles({
        dropdown: {
            "& .list__cell--value": {
                verticalAlign: "top",
                backgroundColor: "transparent",
            },
            "& .menu": {
                position: "relative",
                "& .btn-dropdown-menu": {
                    float: "right",
                },
            },
        },
        arrow: {
            paddingLeft: "7.5px!important",
        },
        action: {
            gridArea: props?.childTable ? "unset" : "data-action",
            paddingTop: props?.dropdown ? 0 : 2,
            paddingRight: "0px!important",
            backgroundColor: "transparent",
            borderLeft: props?.drawer || props?.childTable
                ? {}
                : [1, "solid", THEME.palette.gray.cloud.color],
            minHeight: 30,
            width: 32,
        },
    });
    return useStyles();
}
